import React from "react";
import "./AccessDenied.css";
import { ReactComponent as Lock } from "../../assets/icons/portfolio/redLock.svg";
import Header from "../../components/header/Header";
import Button from "../../components/button/Button";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const AccessDenied = ({text}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <div className="AccessDenied">
    <Header hasMenu2={true} />

    <div className="AccessDeniedWrapper">
        <div className="Error">
            <div className="errorData">
                <Lock />
                <h2>{text}</h2>
            </div>
            <h3>{t("BAN.supportContact")}</h3>
            <Button text={t("portfolioError.back")} onClick={() => navigate("/")} />
            </div>
        </div>
    </div>
  );
};

export default AccessDenied;
